module.exports = __webpack_public_path__ + "static/media/YearbookCover.3118d308.png";